import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2478d5fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "container",
  ref: "container",
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Skjálfti", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "qi-desc" }, "Dags", -1))
const _hoisted_4 = { class: "qi-detail" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "qi-desc" }, "Breidd", -1))
const _hoisted_6 = { class: "qi-detail" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "qi-desc" }, "Lengd", -1))
const _hoisted_8 = { class: "qi-detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "qi-desc" }, "Dýpi", -1))
const _hoisted_10 = { class: "qi-detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "qi-desc" }, "Stærð", -1))
const _hoisted_12 = { class: "qi-detail" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "qi-desc" }, "Gæði", -1))
const _hoisted_14 = { class: "qi-detail" }
const _hoisted_15 = {
  id: "footer",
  class: "content has-text-centered"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-list" }, [
  /*#__PURE__*/_createTextVNode("Created by "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:blitzkopf@gmail.com" }, "Yngvi Þór"),
  /*#__PURE__*/_createTextVNode(" using Three.js, data provided by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.rasmuskr.dk",
    target: "_blank"
  }, "RasmusKr"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.vedur.is/" }, " Veðurstofa Íslands ")
], -1))
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_sidebar = _resolveComponent("o-sidebar")!
  const _component_Mapper = _resolveComponent("Mapper")!
  const _component_Controls = _resolveComponent("Controls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_o_sidebar, {
      open: true,
      fullheight: false,
      overlay: false,
      right: true
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              _createTextVNode(),
              _createElementVNode("td", _hoisted_4, _toDisplayString(new Date(_ctx.qDetail.time ).toLocaleString('en-GB')), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createTextVNode(),
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.qDetail.lat), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createTextVNode(),
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.qDetail.lon), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createTextVNode(),
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.qDetail.depth), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              _createTextVNode(),
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.qDetail.size), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createTextVNode(),
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.qDetail.quality), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showDetail]
    ]),
    _createVNode(_component_Mapper, {
      ref: "mapper",
      onMapLoaded: _ctx.loadMapHandler
    }, null, 8, ["onMapLoaded"]),
    _createVNode(_component_Controls, { onQuakesLoaded: _ctx.quakesLoaded }, null, 8, ["onQuakesLoaded"]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("span", { innerHTML: _ctx.attribution }, null, 8, _hoisted_17)
    ])
  ], 512))
}